import { flow } from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { storeCompletion } from '../../store/task';
import withPager from '../../hocs/Pager';
import PagerButton from './PagerButton';

const mapDispatchToProps = dispatch => ({
  onMount: id => {
    dispatch(storeCompletion(id));
  }
});

export default flow(
  connect(
    null,
    mapDispatchToProps
  ),
  withRouter,
  withPager
)(PagerButton);



// WEBPACK FOOTER //
// ../core/src/components/PagerButton/index.js